import { FunctionComponent, Suspense, lazy } from 'react'

import { LoadingTurbo } from 'atoms'
import { useBreakpointValue } from 'native-base'

import { TabCommonProps } from './types'

const ClassificationMobile = lazy(() => import('./mobile'))

const ClassificationDesktop = lazy(() => import('./desktop'))

export const Classification: FunctionComponent<TabCommonProps> = (props) => {
  const isMobile = useBreakpointValue({ base: true, lg: false })

  const Component = isMobile ? ClassificationMobile : ClassificationDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Component {...props} />
    </Suspense>
  )
}
